import { useContext, useEffect } from 'react'
import { Navigate, Outlet, useLocation, useNavigate } from 'react-router-dom'
import useGetData from '../hooks/useGetData'
import Button from '../components/UI/Button'
import RenderIf from '../components/UI/RenderIf'
import { authContext } from '../context/auth-context'
import taskApi from '../services/taskApi'
import classes from '../styles/Tasks.module.css'
import TasksTable from '../components/Table/TasksTable'
import FormSpinner from '../components/UI/FormSpinner'

const Tasks = () => {
  const { token, authUser } = useContext(authContext)

  const { data: departments } = useGetData({
    queryKey: 'departments',
    queryFn: () => taskApi.fetchDepartments(token),
  })

  const { data: tasks, isLoading: tasksLoading } = useGetData({
    queryKey: 'tasks',
    queryFn: () => taskApi.getTasks(token),
  })

  const navigate = useNavigate()
  const { pathname } = useLocation()
  const isExactPath = pathname === '/tasks'

  useEffect(() => {
    document.title = 'Tasks - Analog Group'
  }, [])

  if (authUser?.user_type !== 'ADMINISTRATOR') {
    return <Navigate to='/login' />
  }

  return (
    <div className={classes.task_container}>
      <RenderIf isTrue={isExactPath}>
        <div className={`${classes.header_container} mb-4`}>
          <h4 id='formTitle'>Tasks</h4>
          <Button onClickHandler={() => navigate('create-task')} text='Create Task' />
        </div>
        <RenderIf isTrue={tasksLoading}>
          <div className='centerSpinner'>
            <FormSpinner color='#0d6efd' />
          </div>
        </RenderIf>
        <RenderIf isTrue={!tasksLoading}>
          <TasksTable tasks={tasks} />
        </RenderIf>
      </RenderIf>
      <RenderIf isTrue={!isExactPath}>
        <Outlet context={{ departments, tasks }} />
      </RenderIf>
    </div>
  )
}

export default Tasks
